import '../../css/Menu.css';
import CerrarSesion from './CerrarSesion';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { useEffect, useState } from 'react';
import { dB64 } from '../../shared/Encriptacion';

export default function Menu({aviso, funcionAviso}){
    //#region STATE
    const [estadoMenu, setEstadoMenu] = useState(false);
    //#endregion

    //#region NAVIGATE
    const navigate = useNavigate();
    //#endregion

    //#region HANDLERS
    const HandlerEstadoMenu = (valor) => setEstadoMenu(valor);
    //#endregion

    //#region FUNCIONES
    const redireccion = (destino) => {
        if(aviso == true){
            funcionAviso(destino);
        }else{
            navigate(`/${destino}`);
        }
    }

    function despliegueMenu(){
        let menu = document.getElementById('contenedor-menu');
        let icono = document.querySelector('.desplegar-menu');

        if(estadoMenu == false){
            menu.style.left='0px';
            icono.style.transform='rotate(180deg)';
            icono.style.color='rgb(182, 56, 196)';
            icono.style.left='245px';
            setTimeout(()=>{
                HandlerEstadoMenu(true)
            },400);
        }else{
            icono.style.transform='rotate(0deg)';
            icono.style.color='rgb(194, 194, 194)';
            icono.style.left='20px';
            menu.style.left='-300px';
            setTimeout(()=>{
                HandlerEstadoMenu(false)
            },400);
        }
    }
    //#endregion

    //#region CONTENIDO
    return(
        <>
        <svg onMouseOver={despliegueMenu} onClick={despliegueMenu} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 426.27 362" width="35px" fill='currentColor' className='desplegar-menu'>
            <g id="Capa_2" data-name="Capa 2">
                <g id="Capa_1-2" data-name="Capa 1">
                    <path d="M303.27,0V79s-350,38-298,283c0,0,9-151,298-191v77l123-123Z"/>
                </g>
            </g>
        </svg> 
        <div onMouseEnter={despliegueMenu} onMouseLeave={despliegueMenu} id='contenedor-menu' className="p-0">
            <div id='mascara-menu'>
                <div className='w-100 h-100'>
                    <div className='margen'></div>
                    <div className='d-flex'>                 
                        <div className='py-3 px-1'>
                            <img src={logo} alt="Sistemas SVEN" width="100px" className='user-select-none'/>
                        </div>
                        <div className='d-flex align-items-center'>
                            <div className='text-white px-1'>
                                <div className='fw-bold text-capitalize'>{localStorage.getItem("r2").toLowerCase()}</div>
                                <div className='text-warning text-capitalize'>{dB64(localStorage.getItem("r5")).toLowerCase()}</div>
                            </div>                            
                        </div>
                    </div>
                    <div className='contenedor-lista'>
                        <ul className='p-2'>
                            <li className='elemento-menu' onClick={e=>redireccion('guias')}><Link>GUÍAS DE REMISIÓN</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('usuarios')}><Link>USUARIOS</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('series')}><Link>SERIES</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('clientes-proveedores')}><Link>CLIENTES/PROVEEDORES</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('productos')}><Link>PRODUCTOS</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('transportistas')}><Link>TRANSPORTISTAS</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('conductores')}><Link>CONDUCTORES</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('vehiculos')}><Link>VEHÍCULOS</Link></li>
                            <li className='elemento-menu' onClick={e=>redireccion('direcciones')}><Link>DIRECCIONES FRECUENTES</Link></li>
                        </ul>
                    </div>
                    <CerrarSesion/>
                    <div className='margen'></div>
                </div>
            </div>
        </div>
        </>
    );
    //#endregion
}